module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGbb300d9596eaabffb04f0c6eea0d37e3.bb300d95.png";